import React from "react";
import { useState } from "react";
import './home.css'
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css";


const sliderData = [
    {
	  image: "img/bg_main_img/MainLanding.png",
	  text: " Delivering reliable, high-performance conveyor systems designed for operational excellence.",
	},
    {
	  image: "img/bg_main_img/landingNew.png",
	  text: "Built to Move. Designed to Perform.",
	},
    
	{
	  image: "img/bg_main_img/conveyor_wep.webp",
	  text: "Streamline Your Operations with Our Reliable Conveyor Belt Solutions",
	},
	{
	  image: "img/bg_main_img/mainImages-transformed.png",
	  text: "Your Trusted Partner for High-Quality Conveyor Belt Parts",
	},
	{
	  image: "img/slider_img/roller_wep.webp",
	  text: "Powering Your Operations with Premium Bearings, Rollers, and Sprockets",
	},
	{
	image:"img/slider_img/gearbox_web.webp",
	text:"Drive Efficiency and Power with Our High-Quality Motor Gearboxes",
	},
	{
		image:"img/bg_main_img/service.jpg",
		text:"Comprehensive Conveyor Services"
	}
  ];

const Slider = () => {
	const [activeIndex, setActiveIndex] = useState(0);

	const handleSlideChange = (swiper) => {
		setActiveIndex(swiper.realIndex); // Update the active index
	  };
	
	
	return(<Swiper
		modules={[Autoplay, Pagination, Navigation]}
		autoplay={{ delay: 5000, disableOnInteraction: false }}
		pagination={{ clickable: true }}
		navigation
		loop={true}
		onSlideChange={handleSlideChange}
		className="swiper-container"
		id="home"
	  >
		{sliderData.map((slide, index) => (
		  <SwiperSlide key={index} className="swiper-slide">
			<div
			  className="slide-content"
			  style={{
				backgroundImage: `url(${slide.image})`,
			  }}
			>
			  {index === activeIndex && (
				<motion.div
				  className="animated-text"
				  initial={{ opacity: 0, y: 50 }}
				  animate={{ opacity: 1, y: 0 }}
				  exit={{ opacity: 0, y: -50 }}
				  transition={{ duration: 1 }}
				>
				  {slide.text}
				</motion.div>
			  )}
			</div>
		  </SwiperSlide>
		))}
	  </Swiper>)}


export default Slider;